var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIonicIosAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 26.765 26.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-add",
    "data-name": "Icon ionic-ios-add",
    d: "M34.063,20.681H24.014V10.631a1.666,1.666,0,0,0-3.333,0v10.05H10.631a1.666,1.666,0,0,0,0,3.333h10.05v10.05a1.666,1.666,0,0,0,3.333,0V24.014h10.05a1.666,1.666,0,0,0,0-3.333Z",
    transform: "translate(-8.965 -8.965)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIonicIosAdd);
export default __webpack_public_path__ + "static/media/Icon-ionic-ios-add.ae0590956a624fd56fedca3b5ce66ab6.svg";
export { ForwardRef as ReactComponent };